import TranslationOfTextContentResourceModel from '../../generated/types/model/resource/TranslationOfTextContentResourceModel';

export default class TranslationOfTextContentResourceViewModel extends TranslationOfTextContentResourceModel {
  // For instructions on how to use ViewModels visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/155/ViewModels-Models-DTOs
}
